export * from './../shared/vuex/map/getters';
import AWS from 'aws-sdk/global';
import {
    isMobile as isMobileDevice, isMobileOnly,
} from 'mobile-device-detect';

import {FLOOR_NAME_TYPES} from '../utils/constants/other'

//Locale
export const getActiveLocale = state => state.activeLocale;

//Services
export const getServiceCategoriesRoot = ({map, listsAndItems}) => listsAndItems.find(c => c.id === map.lists.service_root_category);

export const getServiceCategories = ({listsAndItems}, getters) => {
    const rootCat = getters.getServiceCategoriesRoot;
    return rootCat ? listsAndItems.filter(c => c.lft > rootCat.lft && c.lft <= rootCat.rgt && c.root_id === rootCat.root_id) : [];
};

export const getServicesCategoriesRootLevel = (state, getters) => {
    return getters.getListChildren(getters.getServiceCategoriesRoot.id);
};
export const getOrderedServiceCategories = (state, getters) => _.orderBy(getters.getServiceCategories, ['rgt'], ['asc']);
export const getServiceCategoriesAZ = (state, getters) => getters.getServiceCategories.sort((a, b) => getters.t(a, "name").localeCompare(getters.t(b, "name"), 'sv'));
export const getServices = ({objects}, getters) => getters.getUniqueObjects.filter(item => item.type === getters.getMvData.config.categories['target_zone_service_category']);

export const getServicesObjects = ({objects},getters) => getters.getUniqueObjects.filter((obj) => obj.type === 'service');
export const getServicesObjectsAZ = (state, getters) => getters.getServicesObjects.sort((a, b) => getters.t(a, "name").localeCompare(getters.t(b, "name"), 'sv'));

export const getObjectClosestEntranceId = ({objects}, getters) => (objectOrId) => {
    const object = typeof objectOrId === 'object' ? objectOrId : getters.getDenormalisedObjectById(objectOrId);
    if(object?.meta?.closest_entrance)
        return object.meta.closest_entrance;

    if(object?.floor.meta?.closest_entrance)
        return object.floor.meta.closest_entrance;

    const building = getters.getBuildingByIndex( object.floor.meta.building_index);
    if(building?.meta.closest_entrance)
        return building.meta.closest_entrance;

    return getters.getMapConfigProp('guide.default_entrance');
}

export const getObjectByFirstMatchedId = ({objects}, getters) => (ids = []) => {
    let foundObject = null;

    ids.every((id) => {
        foundObject = id && getters.getDenormalisedObjectById(id);
        return !foundObject;
    });

    return foundObject;
}

export const getEntrances = (state, getters) => getters.getUniqueObjects.filter(item => item.type === 'portal' && item.meta.is_entrance);
export const getElevators = (state, getters) => getters.getUniqueObjects.filter(item => item.type === 'portal' && item.meta.portal_type === 'Elevators');
export const getEntrancesAZ = (state, getters) => getters.getEntrances.sort((a, b) => getters.t(a, "name").localeCompare(getters.t(b, "name"), 'sv'));

export const getPortalsForCatalogue = (state, getters) => getters.getUniqueObjects.filter(item => item.type === 'portal' && item.meta.show_in_catalogue);
export const getPortalsForCatalogueAZ = (state, getters) => getters.getPortalsForCatalogue.sort((a, b) => getters.t(a, "name").localeCompare(getters.t(b, "name"), 'sv'));

//Target zones
export const getTargetZones = ({listsAndItems, map}) => {
    return listsAndItems.filter(item => item['parent_id'] === map.lists['tenant_root_target_zone']);
};

//Map
export const getMap = ({map}) => map;
export const getCustomer = ({customer}) => customer;

function mergeInheritedConfigs(themes, themesNames){
    const resultConfig = {};
    const themesChain = [];
    let themeName = themesNames.find( thName => themes[thName]);

    if(!themeName){
        return {};
    }

    while (themeName) {
        const theme = themes[themeName];

        if(!theme){
            console.error(`Theme ${themeName} not found in map data`);
            break;
        }

        themesChain.push(theme);

        if(!theme.parent){
            break;
        }

        themeName = theme.parent;
    }

    _.merge(resultConfig, ...themesChain.reverse());

    return resultConfig;
}

function mergeConfigs(customerConfig, mapConfig){
    const customerKeyedConfig = _.keyBy(customerConfig, 'name');
    const mapKeyedConfig = _.keyBy(mapConfig, 'name');
    const resultConfig = {};
    return _.merge(resultConfig, customerKeyedConfig, mapKeyedConfig);
}

export const getMapConfig = (state, getters) => (ignoreAppLoaded = false) => {
    if(!state.appLoaded && !ignoreAppLoaded){
        return {};
    }

    const themesNames = state.activeMapTheme;
    const customerConfigs = getters.getCustomer?.meta?.map_settings || [];
    const mapConfigs = getters.getMap?.meta?.themes || [];

    const resultConfigs = mergeConfigs(customerConfigs, mapConfigs);
    const resultConfig = mergeInheritedConfigs(resultConfigs,themesNames);

    _.merge(resultConfig, getters.getTerminalConfig);

    return resultConfig;
};

export const getObjectConfig = (state, getters) => object => {
    if(!object) return {}
    const terminalJson = _.get(object, 'meta.customJSON', _.get(object, 'meta.settings', {}));
    if(typeof terminalJson === 'string'){
        return terminalJson === '' ? {} : JSON.parse(terminalJson);
    }
    return terminalJson;
};

export const getTerminalConfig = (state, getters) => getters.getObjectConfig(getters.getTerminal);

export const getDenormalisedTerminal = ({terminalId}, getters) => getters.getDenormalisedObjectById(terminalId);

/**
 * Get specific prop from map config
 *
 * @param {string} path - Path to the prop.
 * @param {string} def - Default value
 * @return {object} map config
 */
export const getMapConfigProp = (state, getters) => ( path, def = null) => {
    return _.get(getters.getMapConfig(false), path, def)
};
//Objects
export const getCategoryById = ({listsAndItems}) => (id) => listsAndItems.find(obj => obj.id === id);
export const getObject = ({objects}) => (object) => typeof object === 'object' ? object : objects.find((obj) => obj.id === object);
export const getObjectsByCategory = ({objects}) => (categoryId, listsProp = null) => objects.filter(
    (obj) => listsProp
        ? obj.lists[listsProp] && obj.lists[listsProp].includes(categoryId)
        : _.flatten(Object.values(obj.lists).filter(l => typeof l === 'object')).includes(categoryId)
);
export const getObjectsByCategoryAZ = (state, getters) => (categoryId, listsProp = null) => getters.getObjectsByCategory(categoryId, listsProp).sort((a, b) => getters.t(a, "name").localeCompare(getters.t(b, "name"), 'sv'));

export const getDenormalisedObjects = ({objects}, getters) => getters.denormaliseMapObjects(objects);
export const getUniqueObjects = ({objects},getters) => _.uniqBy(getters.getDenormalisedObjects, 'id');

export const getDenormalisedObjectById = ({objects}, getters) =>
    (id, unit = null, alias = 'ext_index') =>{
        if(!id) return {}
        const preparedId = Number(id) || id;
        return getters.getDenormalisedObjects.find(obj => (obj.id === preparedId || obj.meta[alias] == preparedId || obj.meta.otg_store_id === preparedId) && (!unit || obj.unit.name === unit));

    }

export const getPosterBindingTenants = (state, getters) => posterId => {
    return getters.getDenormalisedObjects
        .filter(object => object?.meta?.binding_posters?.includes(posterId))
        .filter(object => object?.type === 'tenant')
        || []
}

export const getPosterBindingServices = (state, getters) => posterId => {
    return getters.getDenormalisedObjects
        .filter(object => object?.meta?.binding_posters?.includes(posterId))
        .filter(object => object?.type === 'service')
        || []
}

export const getDenormalisedObjectByIdAndUnit = ({objects}, getters) => (id, unit) => getters.getDenormalisedObjects.find(obj => obj.id === id && obj.unit.name === unit);
export const getDenormalisedObjectsById = ({objects}, getters) => (id) => getters.getDenormalisedObjects.filter(obj => obj.id === id);

export const getObjectPropById = ({objects}, getters) => (id, prop, def = null) => getters.t(getters.getDenormalisedObjectById(id), prop, def);
export const gop = ({objects}, getters) => (id, prop, def = null) => getters.t(getters.getDenormalisedObjectById(id), prop, def);

export const getObjectFloorName = ({}, {getDenormalisedObjectById, t, t2}) => 
    (objectOrId, shortFloorName = false, isCustomFloorName = true, showOnlyFloor = false, isShowFloorAndBuilding = false) => {
        const obj = typeof objectOrId === 'object' ? objectOrId : getDenormalisedObjectById(objectOrId);

        if(shortFloorName) {
            return t(obj?.meta, 'floor') || obj.floor && t(obj?.floor?.meta, 'floor') +' '+ obj?.floor?.building_index
        }

        if(isCustomFloorName && t(obj?.meta, 'floor')) {
            return _.capitalize(t(obj?.meta, 'floor'))
        }

        if(isCustomFloorName && t2(obj, 'floor')) {
            return _.capitalize(t2(obj, 'floor'))
        }

        if(showOnlyFloor) {
            return t(obj?.floor, 'name') || ''
        }

        if(isShowFloorAndBuilding) {
            return t2(obj, 'floor')
        }
        
        return  obj?.floor?.building_index ?
            _.capitalize(_.replace(obj?.floor?.building_index, '_', ' ')) + ', ' +
            t(obj?.floor, 'name') : '';
    }

export const getObjectFloorNameWithTypeOfName = ({}, {getDenormalisedObjectById, t, t2}) => 
    (objectOrId, floorNameType, debugId) => {
        const obj = typeof objectOrId === 'object' ? objectOrId : getDenormalisedObjectById(objectOrId);

        if(debugId && obj.id == debugId) {
            console.table([
                {
                    typeName: FLOOR_NAME_TYPES.FLOOR_AND_BUILDING_INDEX,
                    floorEx: t(obj?.meta, 'floor') || obj.floor && t(obj?.floor?.meta, 'floor') +' '+ obj?.floor?.building_index
                },
                {
                    typeName: FLOOR_NAME_TYPES.FLOOR_NAME,
                    floorEx: _.capitalize(t(obj?.meta, 'floor')) || _.capitalize(t2(obj?.meta, 'floor'))
                },
                {
                    typeName: FLOOR_NAME_TYPES.FLOOR_NAME_FROM_FLOOR_META,
                    floorEx: t(obj?.floor, 'name') || ''
                },
                {
                    typeName: FLOOR_NAME_TYPES.FLOOR_AND_BUILDING,
                    floorEx: t2(obj, 'floor') || ''
                },
                {
                    typeName: 'default',
                    floorEx: obj?.floor?.building_index ?
                        _.capitalize(_.replace(obj?.floor?.building_index, '_', ' ')) + ', ' +
                        t(obj?.floor, 'name') : ''
                },
            ])
        }

        switch (floorNameType) {
            case FLOOR_NAME_TYPES.FLOOR_AND_BUILDING_INDEX:
                return t(obj?.meta, 'floor') || obj.floor && t(obj?.floor?.meta, 'floor') +' '+ obj?.floor?.building_index
            case FLOOR_NAME_TYPES.FLOOR_NAME && t(obj?.meta, 'floor'):
                return _.capitalize(t(obj?.meta, 'floor'))
            case FLOOR_NAME_TYPES.FLOOR_NAME && t2(obj?.meta, 'floor'):
                return _.capitalize(t2(obj?.meta, 'floor'))
            case FLOOR_NAME_TYPES.FLOOR_NAME_FROM_FLOOR_META:
                return t(obj?.floor, 'name') || ''
            case FLOOR_NAME_TYPES.FLOOR_AND_BUILDING:
                return t2(obj, 'floor') || ''
            case FLOOR_NAME_TYPES.LOCATION_AND_FLOOR:
                const f = t2(obj, 'floor');
                const l = t2(obj, 'location')
                if(f && l) {
                    return t2(obj, 'floor') + ' | ' + t2(obj, 'location')
                } else if (f && !l) {
                    return t2(obj, 'floor')
                }else if (!f && l) {
                    return t2(obj, 'location')
                }
                return obj?.floor?.building_index ?
                    _.capitalize(_.replace(obj?.floor?.building_index, '_', ' ')) + ' | ' +
                    t(obj?.floor, 'name') : '';
            default:
                return  obj?.floor?.building_index ?
                    _.capitalize(_.replace(obj?.floor?.building_index, '_', ' ')) + ', ' +
                    t(obj?.floor, 'name') : '';
        }
    }

//Lists
export const getListItem = ({listsAndItems}) => (id) => listsAndItems.find(c => c.id === id);
export const getListChildren = ({listsAndItems}) => (parentId) => listsAndItems.filter(c => c.parent_id === parentId);
export const getListDescendants = ({listsAndItems}, getters) => (id) => {
    const rootCat = getters.getListItem(id)
    return rootCat ? listsAndItems.filter(c => c.lft > rootCat.lft && c.lft <= rootCat.rgt && c.root_id === rootCat.root_id) : []
};
export const getRootCategories = ({ listsAndItems }) => listsAndItems.filter(c => c['parent_id'] === null);
export const getListDescendantsAndSelf = ({ listsAndItems }, getters) => (id) => {
    const rootCat = getters.getListItem(id)
    return rootCat ? listsAndItems.filter(c => c.lft >= rootCat.lft && c.lft <= rootCat.rgt && c.root_id === rootCat.root_id) : []
}

//Tenants
export const getTenants = ({objects}, getters) => getters.getUniqueObjects.filter((obj) => obj.type === 'tenant');
export const getTenantsAZ = ({objects}, getters) => getters.getTenants.sort((a, b) => getters.t(a, "name").localeCompare(getters.t(b, "name"), 'sv'));
export const getTenantsByCategory = ({objects}, getters) => (categoryId, listsProp = null) => {
    if(!categoryId){
        return [];
    }

    const cid = typeof categoryId === 'number' ? categoryId : parseInt(categoryId);

    return getters.getTenantsAZ.filter(
        (obj) => listsProp
            ? obj.lists[listsProp] && obj.lists[listsProp].includes(cid)
            : _.flatten(Object.values(obj.lists).filter(l => typeof l === 'object')).includes(cid)
    );
}
export const getTenantCategoriesRoot = ({ map, listsAndItems }) => listsAndItems.find(c => c.id === map.lists['tenant_root_category'])

//Buildings
export const getBuildings = ({objects}, getters) => getters.getUniqueObjects.filter((obj) => obj.type === 'building');
export const getBuildingByIndex = ({objects}, getters) =>
    (buildingIndex) => getters.getBuildings.find( b => b.meta.building_index === buildingIndex);

// Main menu

export const getMainMenuRoot = ({ map, listsAndItems }) => listsAndItems.find(c => c.id === map.lists['root_main_menu']);
export const getMenuItems = ({ listsAndItems }, getters) => {
    const rootCat = getters.getMainMenuRoot;
    return rootCat ? listsAndItems.filter(c => c.lft > rootCat.lft && c.lft <= rootCat.rgt && c.root_id === rootCat.root_id ) : []
}

//Categories

export const getTenantRootCategoryChildren = ({ listsAndItems }, getters) => {
    const rootCategory = getters.getTenantCategoriesRoot;
    return rootCategory ? getters.getChildCategories(rootCategory.id) : [];
}
export const getCategories = ({ listsAndItems }, getters) => {
    const rootCategory = getters.getTenantCategoriesRoot;
    const lists = listsAndItems.filter(c => c.lft > rootCategory.lft && c.lft <= rootCategory.rgt && c.root_id === rootCategory.root_id);

    return rootCategory ? lists: [];
};
export const getCategoriesAZ = ({ objects}, getters) => getters.getCategories.sort((a, b) => getters.t(a, "name").localeCompare(getters.t(b, "name"), 'sv'));

//Brands
export const getBrandsRoot = ({ map, listsAndItems }) => listsAndItems.find(c => c.id === map.lists.tenant_root_brand);
export const getBrands = ({ listsAndItems }, getters) => {
    const rootCat = getters.getBrandsRoot
    return rootCat ? listsAndItems.filter(c => c.lft > rootCat.lft && c.lft <= rootCat.rgt && c.root_id === rootCat.root_id) : []
}
export const getBrandsAZ = ({ objects }, getters) => getters.getBrands.sort((a, b) => getters.t(a, "name").localeCompare(getters.t(b, "name"), 'en'));

// Models
export const getModels = ({models}) => models;

//Units
export const getUnitByName = ({units}) => (unitName) => units.find((u) => u.name === unitName);

export const getObjectsByUnitName = ({ objects }, getters) => (unitName, objType = null) => {
    const unit = getters.getUnitByName(unitName);
    return unit ? _.filter(objects, (obj) => obj.units.indexOf(unit.id) !== -1 && (!objType || obj.type === objType)) : [];
};

// Floors
export const getFloors = ({objects}, getters) =>
    _.orderBy(
        getters.getUniqueObjects.filter((obj) => obj.type === 'floor'),
        [
            (f) => f.meta.building_index,
            (f) => f.meta.level,
        ], ['asc', 'desc']
    );

export const getBuildingFloors = ({objects}, getters) => buildingIndex => {
    return getters.getFloors.filter(floor => floor.meta.building_index == buildingIndex)
}

export const getFloorTenants = ({objects}, getters) => floorgId => {
    return getters.getDenormalisedObjects.filter(tenant => tenant.floor.id == floorgId && tenant.type === 'tenant')
}
//Terminal
export const getTerminal = ({terminalId}, getters) => getters.getObject(terminalId);
export const isTerminalStatisticsEnabled = (state, getters) => !getters.getTerminal?.meta?.disable_statistics;

export const getTerminalId = ({terminalId},) => terminalId;
export const getTerminals = ({objects}) => objects.filter(obj => obj.type === 'terminal');

//Portals
export const getMapViewerComponent = ({components}) => (props) => _.get(components.mapViewer, props, null);
export const isAppLoaded = ({appLoaded}) => appLoaded;

// unified way to get localised field of an object
export const t = ({activeLocale, defaultLocale, map}) => (object, field, defaultResult = '') => {

    if (!object)
        return defaultResult;

    // if object has direct field
    if (object[field] !== undefined)
        return object[field];

    // if object has translated field in meta
    if (object.meta) {

        if (object.meta[`${field}_${activeLocale}`] !== undefined && object.meta[`${field}_${activeLocale}`] !== null)
            return object.meta[`${field}_${activeLocale}`];

        if (object.meta[`${field}_${defaultLocale}`] !== undefined && object.meta[`${field}_${defaultLocale}`] !== null)
            return object.meta[`${field}_${defaultLocale}`];

        if (object.meta[field] !== undefined && object.meta[field] !== null )
            return object.meta[field];

        for (const el of map.meta.languages) {
            if (object.meta[`${field}_${el}`] !== undefined && object.meta[`${field}_${el}`] !== null)
                return object.meta[`${field}_${el}`];
        }
    }

    if (object.files) {
        if (object.files[field] !== undefined)
            return object.files[field]
    }

    return defaultResult
};

export const t2 = ({activeLocale, defaultLocale}) => (object, field, defaultResult = '') => {

    if (!object)
        return defaultResult;

    // if object has translated field in meta
    if (object.meta) {
        
        if (object.meta[`${field}_${activeLocale}`] !== undefined && object.meta[`${field}_${activeLocale}`] !== null)
            return object.meta[`${field}_${activeLocale}`];

        if (object.meta[`${field}_${defaultLocale}`] !== undefined && object.meta[`${field}_${defaultLocale}`] !== null)
            return object.meta[`${field}_${defaultLocale}`];

        if (object.meta[field] !== undefined && object.meta[field] !== null )
            return object.meta[field];
    }

    if (object.files) {
        if (object.files[field] !== undefined)
            return object.files[field]
    }

    return defaultResult
};

export const getMapLoading = state => state.mapLoading;

export const getMvData = (state, getters) => {
    const result = {};

    result.config = getters.getMapConfig(false);
    result.models = state.models;
    result.units = getters.getDenormalisedUnits;
    result.objects = getters.getDenormalisedObjects;
    result.b2bg = getters.getBuilding2GroupRelations

    if(state.terminalId)
        result.terminalUnitName = getters.getTerminal.unitNames[0];

    return result
};

export const getDenormalisedUnits = ({ map }, getters) => {
    return getters.getDenormalisedMapUnits(null, ['dae_unit','virtual_unit']);
};

export const getDeviceFamilyThemeSuffix = (state, getters) => {
    return getters.isElo && '-elo' ||
        getters.isTizen && '-tizen' ||
        getters.isLinux && '-linux' ||
        '-web';
}

export const isMobile = () => isMobileDevice;
export const isTerminal = () => document.location.href.includes('/terminal-');

export const isEmbed = () => window.parent !== window.self;
export const isNative = (state) => state.activeMapTheme?.[0]?.includes('native');
export const isLinux = () => navigator.userAgent.includes('Linux x86_64');
export const isTizen = () => navigator.userAgent.includes('Tizen');
export const isElo = () => navigator.userAgent.includes('Elo-') ||
    navigator.userAgent.includes('msm8953') ||
    navigator.userAgent.includes('Backpack-');

export const getSourceType = (state, getters) =>
    getters.isElo && 'elo' ||
    getters.isTizen && 'tizen' ||
    getters.isLinux && 'linux' ||
    getters.isNative && 'native' ||
    getters.isEmbed && 'embed' ||
    'browser';

export const getSource = (state, getters) => {
    if (getters.isTerminal)
        return 'terminal';

    if (getters.isMobile)
        return 'mobile';

    return 'desktop';
};

//Categories

export const getChildCategories = ({ listsAndItems }) => (parentId) => listsAndItems.filter((cat) => cat.parent_id === parentId);

export const getBaseEventData = (state, getters) => ({
    cid: state.map?.customer_id,
    mid: state.map ? state.map.id : null,
    tid: state.terminalId || null,
    uid: _.get(AWS, 'config.credentials.identityId', 'NotSet'),
    sid: state.sessionId,

    source: getters.getSource,
    source_type: getters.getSourceType,
    source_id: state.terminalId
});

export const getObjectModelIds = ({ objects, units, models }, getters) => (object) => {
    const obj = getters.getObject(object)
    return obj && obj.units ? _.uniq(obj.units.map(u => getters.getUnit(u).map_model_id)) : []
};
export const getPropsMapping = ({ activeLocale, defaultLocale }, getters) => {
    return {
        name: `name_${activeLocale}`,
        floor: `floor_${activeLocale}`
    };
};

//Movies
export const getMovieById = ({ moviesList }) => id => {
    return moviesList.filter(el => {
        return el.movie_id === id;
    })[0];
};

export const getMovieData = ({ showsData }) => id => {
    return showsData.filter(el => {
        return el.MovieVersionId.includes(id);
    });
};

export const getActiveGuideDestinationUnit = ({ activePath }) => {
    if (!_.has(activePath, 'steps')) return null;

    const lastStep = activePath.steps.slice(-1).pop();
    if (!lastStep) return null;

    const lastStepParameter = lastStep.parameters.find(p => p.name === 'unit');
    if (!lastStepParameter) return null;

    return lastStepParameter.value;
};

export const getMyPosition = state => state.myPosition;

export const getObjectsWithNumbers = (state, getters) => {
    const isSortIndexesDown = _.get(getters.getMapConfig(true), 'components.TPosters.params.is_sort_indexes_down')
    const objectsWithUnitAlias = getters.getDenormalisedObjects.filter(object => getters.getUnitAlias(object));
    
    let objectsWithNumbers = addFloorIndex(objectsWithUnitAlias, getters)

    objectsWithNumbers = addObjectIndexes(objectsWithNumbers, getters, isSortIndexesDown)

    return objectsWithNumbers
};

export const getUnitAlias = (state, getters) => item => getters.getUnit(item.unit.id).alias || false;

export const getObjectIndex = (state, getters) => item => getters.getObject(item.id)?.index?.index || '';
export const getObjectFloorIndex = (state, getters) => item => getters.getObject(item.id)?.index?.floorIndex || '-';

export const getDeviceType = () => {
    const href = window.location.href;
    switch(true){
        case href.includes('/posters'):
            return 'poster';
        case href.includes('/integrations/web'):
            return 'web_app';
        case href.includes('/terminal-'):
            return 'terminal';
        default:
            return ''
    }
};

export const getBaseAppThemeName = () => {
    const href = window.location.href;
    switch(true){
        case href.includes('/posters'):
            return 'poster';
        case href.includes('/integrations/web'):
            return 'web-integration2';
        case href.includes('/terminal-'):
            return 'terminal2';
        default:
            return ''
    }
};

/**
 * We add floorIndex to object, based on Unit Alias and floor number, 
 * @param {Array} objects 
 * @returns {Array}
 */
const addFloorIndex = (objects, getters) => {
    let groupedObjects = _.groupBy(objects, 'floor.level')
    groupedObjects = Object.entries(groupedObjects).map(([floor, objects]) => ({
        floor,
        objects: addObjectIndexes(objects, getters)
    }))

    const objectsWithFloorIndex =  []

    groupedObjects.forEach(({floor, objects}) => {
        objects.forEach(object => {
            const newObject = {
                ...object,
                index: {
                    ...(object.index ? object.index : {}),
                    floorIndex: getFloorIndex(object, objects, floor)
                },
            }
            objectsWithFloorIndex.push(newObject)
        });
    });

    return objectsWithFloorIndex
}

/**
 * We add index to object, based on Unit Alias, 
 * @param {Array} objects 
 * @returns {Array}
 */
const addObjectIndexes = (objects, getters, isSortIndexesDown = false) => {
    return objects.map(object =>({
        ...object,
        meta: {
            ...object?.meta, 
            unitNumber: getters.getUnitAlias(object)
        }
    }))
        .sort((a, b) => {
            if(isSortIndexesDown) {
                return parseInt(b.meta.unitNumber, 10) - parseInt(a.meta.unitNumber, 10)
            }
            return parseInt(a.meta.unitNumber, 10) - parseInt(b.meta.unitNumber, 10)
            
        })
        .map((object, i, arr) =>({
            ...object,
            index: {
                ...(object.index ? object.index : {}),
                index: arr.findIndex(item => item.meta.unitNumber == object.meta.unitNumber)
            },
        }))
}

const getFloorIndex = (object, objects, floor) => {
    const lastObjectsIndex = objects[objects.length - 1].index.index
    const currentObjectIndex = object.index.index
    const floorNumber = +floor + 1
    const prefix = (lastObjectsIndex > 99 ? 1000 : 100)*floorNumber
    
    if(floorNumber == 0) {
        let zeros = currentObjectIndex < 10 ? '00' : currentObjectIndex < 100 ? '0' : ''
        if(lastObjectsIndex > 99) zeros = zeros + 0
        return zeros + currentObjectIndex
    }
    return prefix + (floorNumber < 0 ? -currentObjectIndex : currentObjectIndex)
}
